import {
  ColorScheme,
  ThemeName,
  ThemeVariant,
} from '@toggle/design-system/src/design-tokens/themes/themes';
import { Entity } from '@toggle/toggle';

import { create } from '~/utils/store/createStore';

import { createThemeName, isDarkTheme } from '../utils/theme-utils/theme-utils';

interface ThemeStore {
  themeName: ThemeName;
  colorScheme: ColorScheme;
  initStore: () => void;
  changeTheme: (colorScheme: ColorScheme, themeVariant: ThemeVariant) => void;
  getThemedLogoUrl: (entity: Entity) => string;
}

const THEME_PARAM_KEY = 'theme';
export const useThemeStore = create<ThemeStore>((set, get) => ({
  themeName: 'light_default',
  colorScheme: ColorScheme.Light,
  initStore: () => {
    const params = new URLSearchParams(window.location.search);
    const url = new URL(window.location.href);
    const theme = params.get(THEME_PARAM_KEY);

    if ((theme && theme === ColorScheme.Light) || theme === ColorScheme.Dark) {
      set({
        colorScheme: theme,
        themeName: `${theme}_default`,
      });
      url.searchParams.delete(THEME_PARAM_KEY);
      window.history.replaceState(null, '', url);
    }
  },
  changeTheme: (colorScheme, themeVariant) => {
    const themeName = createThemeName(colorScheme, themeVariant);

    set({
      themeName,
      colorScheme,
    });
  },
  getThemedLogoUrl: (entity: Entity) => {
    const isDark = isDarkTheme(get().themeName);
    return isDark ? entity.logo_urls.light_png : entity.logo_urls.dark_png;
  },
}));
